import { createDownloadEpic, createEpic } from "../helpers";

import {
	exportJudgeProfilesDataAsyncAction,
	getJudgeSettingsAsyncAction,
	postSettingsAsyncAction,
	getQuestionsListAsyncAction,
	deleteQuestionsByIdAsyncAction,
	getQuestionAsyncAction,
	updateQuestionAsyncAction,
	postQuestionAsyncAction,
	getJudgeProfileListAsyncAction,
	getJudgeProfileAsyncAction,
	updateJudgeProfileAsyncAction,
} from "./judgeActions";

export const getJudgeSettingsEpic = createEpic(
	getJudgeSettingsAsyncAction,
	"judge",
	"getSettings",
	true
);

export const getJudgeProfileListEpic = createEpic(
	getJudgeProfileListAsyncAction,
	"judge",
	"getJudgeProfileList",
	true
);

export const getJudgeProfileEpic = createEpic(
	getJudgeProfileAsyncAction,
	"judge",
	"getJudgeProfile",
	true
);

export const updateJudgeProfileEpic = createEpic(
	updateJudgeProfileAsyncAction,
	"judge",
	"updateJudgeProfile",
	true
);

export const postJudgeSettingsEpic = createEpic(
	postSettingsAsyncAction,
	"judge",
	"postSettings",
	true
);

export const getJudgeQuestionsListEpic = createEpic(
	getQuestionsListAsyncAction,
	"judge",
	"getQuestionsList",
	true
);

export const getQuestionEpic = createEpic(
	getQuestionAsyncAction,
	"judge",
	"getQuestion",
	true
);

export const deleteJudgeQuestionsByIdEpic = createEpic(
	deleteQuestionsByIdAsyncAction,
	"judge",
	"deleteQuestionsById",
	true
);

export const postQuestionEpic = createEpic(
	postQuestionAsyncAction,
	"judge",
	"postQuestion",
	true
);

export const updateQuestionEpic = createEpic(
	updateQuestionAsyncAction,
	"judge",
	"updateQuestion",
	true
);

export const exportJudgeProfilesEpic = createDownloadEpic(
	exportJudgeProfilesDataAsyncAction,
	"judge",
	"exportJudgeProfiles",
	true,
	"judge-profiles"
);
